import classNames from "classnames";
import React from "react";
import { IMessageWidgetConfig } from "../../../../models/messageWidgets/MessageWidgetConfig";
import { Chip, Props as ChipProps } from "../../Chip";
import styles from "./ChipMessageWidget.css";

type Props = Pick<IMessageWidgetConfig, "name"> & Partial<ChipProps>;

export const ChipMessageWidget = ({ name, ...rest }: Props) => {
  return (
    <Chip
      icon={<i className={classNames("icon-person", styles.icon)} />}
      className={styles.chip}
      label={name}
      variant="base"
      {...rest}
    />
  );
};
